import { render, staticRenderFns } from "./exhibit-region.vue?vue&type=template&id=81bd89f6&scoped=true&"
import script from "./exhibit-region.vue?vue&type=script&lang=js&"
export * from "./exhibit-region.vue?vue&type=script&lang=js&"
import style0 from "./exhibit-region.vue?vue&type=style&index=0&id=81bd89f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bd89f6",
  null
  
)

export default component.exports